import React from 'react';

import Chip from 'components/Chip';
import { EmptyValue } from 'components/SharedFormComponents/CustomFieldDisplayValue/styles';

import { getEntityTranslation } from 'stores/EntityDetails/utils';
import { EntityModules } from 'core/constants';

import { LookupAnswerEntry, resolveLookupEntries } from '../lookupRecords';
import { ChipRow } from './styles';

export type LookupRecordsAnswerProps = {
  records: LookupAnswerEntry[];
  module?: EntityModules;
};

/** The review step's read-only twin of the multi-record picker: the same filled chips the auditor just chose. */
const LookupRecordsAnswer = ({ records, module }: LookupRecordsAnswerProps): React.ReactElement => {
  const resolved = resolveLookupEntries(records);
  const singular = module ? getEntityTranslation[module]?.singular : undefined;

  if (resolved.length === 0) {
    return <EmptyValue id="empty-value">-</EmptyValue>;
  }

  return (
    <ChipRow id="lookup-value">
      {resolved.map((record) => (
        <Chip
          key={record.uuid}
          label={record.name}
          tooltipTitle={singular}
          fontSize={14}
          variant="filled"
          data-testid="audit-lookup-answer-chip"
        />
      ))}
    </ChipRow>
  );
};

export default LookupRecordsAnswer;
